import currentUserPreload from "shared/current-user-preload"
import currentUserSelect from "shared/current-user-select"
import Devise from "@kaspernj/api-maker/build/devise"
import {User} from "models"

export {currentUserSelect as select}
export default async function usersUpdateSession(userId) {
  if (userId) {
    const currentUserWithRelationships = await User
      .ransack({id_eq: userId})
      .preload(currentUserPreload)
      .select(currentUserSelect)
      .first()

    // Fail loud instead of silently clearing the signed-in session: if the
    // ransack returns null here (e.g. the WebSocket auth is still pre-sign-in
    // and the policy hides the row), writing null to Devise.updateSession
    // flips the provider to {loaded: true, model: null} and drops the user
    // back on the sign-in screen right after a successful sign-in.
    if (!currentUserWithRelationships) {
      throw new Error(`usersUpdateSession: could not load user ${userId}`)
    }

    Devise.updateSession(currentUserWithRelationships, {scope: "user"})
    Devise.events().emit("onDeviseSignIn")
  } else {
    Devise.setSignedOut({scope: "user"})
    Devise.callSignOutEvent({scope: "user"})
  }
}
